import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-conditions-wrapper',
  templateUrl: './terms-conditions-wrapper.component.html',
  styleUrls: ['./terms-conditions-wrapper.component.css']
})
export class TermsConditionsWrapperComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {

  }
}
